import { useSnapshot } from "valtio"
import Api from "../state/Api"
import { configStore } from "../state/CommonState"
import { fileStore } from "../state/fileStore"
import { useRef } from "react"
import Utils from "../util/Utils"
import { ChooseFile } from "../mui-components/ChooseFile"
let Agmongofileparentid = []

export default function AgFile(props) {
    useSnapshot(fileStore)
    const {parent} = props
    if(parent){
        if(fileStore.props[parent]==undefined){
            fileStore.props[parent] = props
        }
    }
    let parentid = ['ta1','tf8','tf_fcl_carrier']
    console.log('Inside Agfile', props.source, props.cat, props.filetype)
    const {source, cat, filetype, callback, url = '/api/v1/common/receivefile'} = props
    var parent_container=null
    var newHandle = function(e) { 
        let parent_container1 = null
        if(parentid.length>0){
            parent_container = e.target;
            do {
                if (!parent_container) break
                parent_container = parent_container.parentNode;

                if (parent_container && parentid.indexOf(parent_container.id) == -1) {
                    parent_container1 = null
                }else{
                    parent_container1 = parent_container
                }
            }
            while( parent_container1==null && parent_container !== document.body );
            parent_container = parent_container1
        }
    };
    var newHandle1 = function(e) { 
        if(parent && parent_container){
            let i = parent_container.getElementsByTagName('input')
            i[0].files = e.clipboardData.files
            if(e.clipboardData.files.length>0){
                change(i[0].files,fileStore.props[parent_container.id])
            }
        }
    };
    if(parentid.length>0){
        document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
        document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
    
    }

    function change (files,props){
        const {parent} = props
        const {source, cat, filetype, callback, url = '/api/v1/common/receivefile'} = props
        const formData = new FormData()
            formData.append('myFile', files[0])
            formData.append('source', source)
            formData.append('category', cat)
            formData.append('filetype', filetype)
            console.log('FORMDATA=')
            console.log()
            let  newURI = `${process.env.REACT_APP_API_SERVER}${url}`
            if (filetype === 'currency' || filetype === 'finance' || filetype === 'erpreport' || filetype === 'financialDashPerm' || filetype === 'rmCSUpdate' || filetype === 'bulkEntityUpload' || filetype === 'fcl_carrier_list') {
                newURI = `${process.env.REACT_APP_API_SERVER}${url}`
            }
            else {
                newURI = `${process.env.REACT_APP_FILE_SERVER}${url}`
            }
            fetch(`${newURI}`, {
                method: 'POST',
                headers: Api.H1(),
                credentials: Utils.shouldSendCredentials(newURI) ? 'include' : 'omit',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    console.log('got data', data)
                    if (data.error) { if (data.error!='No Error' || data.error!='Invalid Token') { configStore.setModalMessage(data.error) }}
                    else {
                        //console.log('setting the filelink',  `/clientfiles/${files[0].name}`)

                        if (filetype === "rmCSUpdate") {
                            callback(data)
                        } else {
                            callback(data.filename)
                        }
                        document.getElementById(parent).getElementsByTagName('input')[0].value = ""
                    }
                })
                .catch(error => {
                    console.error(error)
                })
    }
    return (
        <div>
        <input type="file" accept={props.accept || ".pdf,image,.csv/*,.xlsx,.xls"} style={{fontSize: '0.8rem'}} onChange={(e) => {
            const pattern = /^\S[\S\s]*\S$|^\S$/;
            if(pattern.test(e.target.files[0]['name'])){
                change(e.target.files,props)
            }else{
                configStore.setModalMessage("Please Check File Name and Format")
                return e.target.value = ""
            }
            
        }} />
        </div>
    )
}



export function AgCustomFile(props) {
    useSnapshot(fileStore)
    const {parent} = props
    if(parent){
        if(fileStore.props[parent]==undefined){
            fileStore.props[parent] = props
        }
    }
    
    console.log('Inside Agfile', props.source, props.cat, props.filetype)
    const {source, cat, filetype, callback, url = '/api/v1/common/receivefile', withBtn = false, multi} = props
    let parentid = ['cwf5', 'cwf6', 'cwf1', 'cwf2', 'cwf3', 'cwf4','cwf7','cwf8','cwf9','cwf10','cwf11','cwf12','cwf13','cw14','co1','co2','co3','co4','co5']
    var parent_container = null
    var newHandle = function(e) { 
        let parent_container1 = null
        if(parentid.length>0 ){
            parent_container = e.target;
            
            do {
                if (!parent_container) break
                parent_container = parent_container.parentNode;
                
                if (parent_container && parentid.indexOf(parent_container.id) == -1) {
                    parent_container1 = null
                }else{
                    parent_container1 = parent_container
                }
            }
            while( parent_container1==null && parent_container !== document.body );
            parent_container = parent_container1
            console.log(parent_container)
        }
    };
    var newHandle1 = function(e) { 
        if(parent && parent_container){
            let i = parent_container.getElementsByTagName('input')
            i[0].files = e.clipboardData.files
            if(e.clipboardData.files.length>0){
                change(i[0].files,fileStore.props[parent_container.id])
                e.stopPropagation()
            }
        }
    };
    if(parentid.length>0){
        document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
        document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
    }
   function change(files, props) {
    const { parent, source, cat, filetype, callback, url = '/api/v1/common/receivefile', withBtn = false, multi,
            onUploadStart, onUploadFinish } = props;

    if (onUploadStart) onUploadStart();

    const formData = new FormData();
    for (let file of files) {
        formData.append("myFile", file);
    }
    formData.append('source', source);
    formData.append('category', cat);
    formData.append('filetype', filetype);

    let newURI =
        filetype === 'currency' || filetype === 'finance'
            ? `${process.env.REACT_APP_API_SERVER}${url}`
            : `${process.env.REACT_APP_FILE_SERVER}${url}`;

    fetch(newURI, {
        method: 'POST',
        headers: Api.H1(),
        credentials: Utils.shouldSendCredentials(newURI) ? 'include' : 'omit',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            console.log('got data', data);

            if (data.error) {
                if (data.error !== 'No Error' || data.error !== 'Invalid Token') {
                    configStore.setModalMessage(data.error);
                }
            } else {
                data?.uploaded?.forEach(u => {
                    callback(u.filename);
                });

                document.getElementById(parent)
                    .getElementsByTagName('input')[0].value = "";
            }
        })
        .catch(error => console.error(error))
        .finally(() => {
            if (onUploadFinish) onUploadFinish();
        });
}

    return (
        <div>
            {
                (multi)?<>
                  {
                withBtn && (<label for={filetype} className="button is-small is-success"> 
                                    <span className="icon has-text-light">
                                        <i className="fas fa-plus"></i>
                                    </span>
                                </label>)
            }
        <input className={withBtn ? "is-hidden" : ""} id={filetype} type="file" multiple accept={filetype||".pdf,image/*"} style={{fontSize: '0.8rem'}}
  onChange={(e) => {
    const pattern = /^\S[\s\S]*\S$|^\S$/;

      for (let file of e?.target?.files) {
        console.log(file);
          if (file.size >= process.env.REACT_APP_FILE_UPLOAD_LIMIT * 1024 * 1024) {
              configStore.setModalMessage(`File size should not exceed ${process.env.REACT_APP_FILE_UPLOAD_LIMIT}MB`);
              return (e.target.value = "");
          }
          if (!pattern.test(file.name)) {
              configStore.setModalMessage("Please check file name and format");
              return (e.target.value = "");
          }
    }
    change(e.target.files, props);
  }}
 />
                </>:<>
                <input type="file" accept={filetype} style={{fontSize: '0.8rem'}} onChange={(e) => {
            // change(e.target.files,props)
            const pattern = /^\S[\s\S]*\S$|^\S$/;
            if(pattern.test(e.target.files[0]['name'])){
                change(e.target.files,props)
            }else{
                configStore.setModalMessage("Please Check File Name and Format")
                return e.target.value = ""
            }
            
        }} />
                </>
            }
         
              
           
        </div>
    )
}

export function AgCustomFileMobile(props) {
    useSnapshot(fileStore)
    const {parent,lisFiles=false} = props
    if(parent){
        if(fileStore.props[parent]==undefined){
            fileStore.props[parent] = props
        }
    }
    
    console.log('Inside AgfileMobile', props.source, props.cat, props.filetype)
    const {source, cat, filetype, callback, url = '/api/v1/common/receivefile', withBtn = false, multi, title, data, onFileDeleted, multiple = false, HideCameraoption = true} = props
    let parentid = ['cwf5', 'cwf6', 'cwf1', 'cwf2', 'cwf3', 'cwf4','cwf7','cwf8','cwf9','cwf10','cwf11','cwf12','cwf13','cw14','co1','co2','co3','co4','co5','co6']
    var parent_container = null
    var newHandle = function(e) { 
        let parent_container1 = null
        if(parentid.length>0 ){
            parent_container = e.target;
            
            do {
                if (!parent_container) break
                parent_container = parent_container.parentNode;
                
                if (parent_container && parentid.indexOf(parent_container.id) == -1) {
                    parent_container1 = null
                }else{
                    parent_container1 = parent_container
                }
            }
            while( parent_container1==null && parent_container !== document.body );
            parent_container = parent_container1
            console.log(parent_container)
        }
    };
    var newHandle1 = function(e) { 
        if(parent && parent_container){
            let i = parent_container.getElementsByTagName('input')
            if(i && i[0]){
                i[0].files = e.clipboardData.files
                if(e.clipboardData.files.length>0){
                    change(e.clipboardData.files, fileStore.props[parent_container.id])
                    e.stopPropagation()
                }
            }
        }
    };
    if(parentid.length>0){
        document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
        document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
    }

    function change(files, props, updateFileState, updateFailureState) {
        const { parent, source, cat, filetype, callback, url = '/api/v1/common/receivefile', withBtn = false, multi,
                onUploadStart, onUploadFinish } = props;

        if (onUploadStart) onUploadStart();

        const formData = new FormData();
        for (let file of files) {
            formData.append("myFile", file);
        }
        formData.append('source', source);
        formData.append('category', cat);
        formData.append('filetype', filetype);

        let newURI =
            filetype === 'currency' || filetype === 'finance'
                ? `${process.env.REACT_APP_API_SERVER}${url}`
                : `${process.env.REACT_APP_FILE_SERVER}${url}`;

        fetch(newURI, {
            method: 'POST',
            headers: Api.H1(),
            credentials: Utils.shouldSendCredentials(newURI) ? 'include' : 'omit',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                console.log('got data', data);

                if (data.error) {
                    if (data.error !== 'No Error' || data.error !== 'Invalid Token') {
                        configStore.setModalMessage(data.error);
                    }
                    if (updateFailureState) updateFailureState();
                } else {
                    if (data?.uploaded?.length > 0) {
                        data.uploaded.forEach(u => {
                            callback(u.filename);
                        });
                    } else if (data.filename) {
                        callback(data.filename);
                    } else if (data.file) {
                        callback(data.file);
                    } else if (files && files.length > 0) {
                        files.forEach(f => callback(f.name));
                    }
                    if (updateFileState) updateFileState();
                }
            })
            .catch(error => {
                console.error(error);
                if (updateFailureState) updateFailureState();
            })
            .finally(() => {
                if (onUploadFinish) onUploadFinish();
            });
    }

    const cameraInputRef = useRef(null);

    const handleCameraClick = () => {
        if (cameraInputRef.current) {
            cameraInputRef.current.click();
        }
    };

    const handleCameraChange = (e) => {
        const file = e?.target?.files?.[0];
        if (file) {
            const pattern = /^\S[\s\S]*\S$|^\S$/;
            if (!pattern.test(file.name)) {
                configStore.setModalMessage("Please Check File Name and Format");
                return;
            }
            change([file], props);
        }
    };

    return (
        <div className="flex flex-col gap-3 w-full items-center">
            {/* Hidden Camera Input and Camera Button for direct camera capture on mobile */}
            {!HideCameraoption && (
                <>
                    <input
                        type="file"
                        ref={cameraInputRef}
                        accept="image/*"
                        capture="environment"
                        style={{ display: 'none' }}
                        onChange={handleCameraChange}
                    />

                    <button
                        type="button"
                        onClick={handleCameraClick}
                        className="w-[200px] h-[40px] rounded-[7px] border border-dashed border-blue-dark bg-white flex flex-col items-center justify-center gap-0.2 cursor-pointer transition-all active:scale-[0.98]"
                    >
                        <svg className="w-5 h-5 text-blue-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span className="text-xs font-semibold text-blue-dark">Camera</span>
                    </button>
                </>
            )}

            {/* ChooseFile Component */}
            <div>
                <ChooseFile
                title={title}
                data={data}
                showFileList={lisFiles}
                multiple={multiple}
                documentView={lisFiles}
                onFileSelected={(fileOrFiles, updateFileState, updateFailureState) => {
                    const filesArray = Array.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];
                    const pattern = /^\S[\s\S]*\S$|^\S$/;
                    for (let f of filesArray) {
                        if (!pattern.test(f.name)) {
                            configStore.setModalMessage("Please Check File Name and Format");
                            if (updateFailureState) updateFailureState();
                            return;
                        }
                    }
                    change(filesArray, props, updateFileState, updateFailureState);
                }}
                onFileDeleted={(file, success, failure) => {
                    if (onFileDeleted) {
                        onFileDeleted(file, success, failure);
                    } else if (success) {
                        success();
                    }
                }}
                direction="row"
            />
            </div>
        </div>
    );
}

export function AgscheduleFile(props) {
    useSnapshot(fileStore)
    const {parent} = props
    if(parent){
        if(fileStore.props[parent]==undefined){
            fileStore.props[parent] = props
        }
    }
    console.log('Inside Agfile', props.source, props.cat, props.filetype)
    const {consolidatorlist={}, uploadShipmentType,  callback, url = '/api/v1/myactions/uploadschedules'} = props
    let parentid = ['ts2','ts1']
    var parent_container = null
    var newHandle = function(e) { 
        let parent_container1 = null
        if(parentid.length>0 ){
            parent_container = e.target;
            do {
                if (!parent_container) break
                parent_container = parent_container.parentNode;

                if (parent_container && parentid.indexOf(parent_container.id) == -1) {
                    parent_container1 = null
                }else{
                    parent_container1 = parent_container
                }
            }
            while( parent_container1==null && parent_container !== document.body );
            parent_container = parent_container1
        }
    };
    var newHandle1 = function(e) { 
        if(parent && parent_container){
            let i = parent_container.getElementsByTagName('input')
            i[0].files = e.clipboardData.files
            if(e.clipboardData.files.length>0){
                change(i[0].files,fileStore.props[parent_container.id])
            }
        }
    };
    if(parentid.length>0){
        document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
        document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
    
    }
    function change(files,props){
        const {parent} = props
        const {consolidatorlist={}, uploadShipmentType,  callback, url = '/api/v1/myactions/uploadschedules'} = props
        const formData = new FormData()
            formData.append('myFile', files[0])
            formData.append('action', 'schedule_upload')
            formData.append('shipmentType', uploadShipmentType)
            formData.append('consolidatorlist', consolidatorlist)
            fetch(`${process.env.REACT_APP_API_SERVER}${url}`, {
                method: 'POST',
                headers: Api.H1(),
                credentials: Utils.shouldSendCredentials(process.env.REACT_APP_API_SERVER) ? 'include' : 'omit',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    console.log('got data', data)
                    if (data.error) { if (data.error!='No Error' || data.error!='Invalid Token') { configStore.setModalMessage(data.error) }}
                    else {
                        //console.log('setting the filelink',  `/clientfiles/${files[0].name}`)
                        callback(data.filename)
                        document.getElementById(parent).getElementsByTagName('input')[0].value = ""
                    }
                })
                .catch(error => {
                    console.error(error)
                })
    }
    return (
        <div>
        <input type="file"  style={{fontSize: '0.8rem'}} onChange={(e) => {
            // change(e.target.files,props)
            const pattern = /^\S[\s\S]*\S$|^\S$/;
            if(pattern.test(e.target.files[0]['name'])){
                change(e.target.files,props)
            }else{
                configStore.setModalMessage("Please Check File Name and Format")
                return e.target.value = ""
            }
            
        }} />
        </div>
    )
}

export function Agmongofile(props) {
    useSnapshot(fileStore)
    const {parent} = props
    if(parent){
        if(fileStore.props[parent] == undefined){
            fileStore.props[parent] = props
        }
    }
    console.log(fileStore.props[parent])
    let url = `${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`
    const {label, filekey, disabled = false, multiple = false, callback = f => f} = props
    if(Agmongofileparentid.indexOf(parent)==-1){
        Agmongofileparentid.push(parent)
    }

    var parent_container = null
    var newHandle = function(e) { 
        let parent_container1 = null
        if(Agmongofileparentid.length>0 ){
            parent_container = e.target;
            do {
                if(parent_container){
                    parent_container = parent_container.parentNode;
                }else{
                    break
                }

                if (parent_container && Agmongofileparentid.indexOf(parent_container.id) == -1) {
                    parent_container1 = null
                }else{
                    parent_container1 = parent_container
                }
            }
            while( parent_container1==null && parent_container !== document.body );
            parent_container = parent_container1
        }
    };
    var newHandle1 = function(e) { 
        if(parent && parent_container){
            let i = parent_container.getElementsByTagName('input')
            i[0].files = e.clipboardData.files
            if(e.clipboardData.files.length>0){
                console.log(fileStore.props[parent_container.id])
                change(i[0].files,fileStore.props[parent_container.id])
            }
        }
    };
    if(Agmongofileparentid.length>0){
        document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
        document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
    
    }
    async function change(files,props){
        const {label, filekey, disabled = false, multiple = false, callback = f => f} = props
        const {parent} = props

        if (multiple && files.length > 1) {
            try {
                let uploadPromises = Array.from(files).map(file => {
                    const formData = new FormData()
                    formData.append('myFile', file)
                    formData.append('label', label)
                    formData.append('key', filekey)
                    return fetch(url, {
                        method: 'POST',
                        headers: Api.H1(),
                        credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit', 
                        body: formData
                    }).then(res => res.json())
                })
                const results = await Promise.all(uploadPromises)
                const errorResult = results.find(data => data.error && data.error !== 'No Error' && data.error !== 'Invalid Token')
                if (errorResult) {
                    configStore.setModalMessage(errorResult.error)
                }
                const successResults = results.filter(data => !data.error && data.key)
                if (successResults.length > 0) {
                    callback(successResults, +parent.split('___')[1])
                }
                if (parent && document.getElementById(parent)) {
                    let inputs = document.getElementById(parent).getElementsByTagName('input')
                    if (inputs && inputs[0]) inputs[0].value = ""
                }
            } catch (error) {
                console.error(error)
            }
            return
        }

        const formData = new FormData()
        formData.append('myFile', files[0])
        formData.append('label', label)
        formData.append('key', filekey)
        fetch(url, {
            method: 'POST',
            headers: Api.H1(),
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit', 
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                
                console.log('got data', data)
                if (data.error) { 
                    if (data.error!='No Error' || data.error!='Invalid Token') { 
                        configStore.setModalMessage(data.error)
                        if (parent && document.getElementById(parent)) {
                            let inputs = document.getElementById(parent).getElementsByTagName('input')
                            if (inputs && inputs[0]) inputs[0].value = ""
                        }
                    }
                }
                else {
                    //console.log('setting the filelink',  `/clientfiles/${files[0].name}`)
                    callback(multiple ? [data] : data, +parent.split('___')[1])
                    if (parent && document.getElementById(parent)) {
                        let inputs = document.getElementById(parent).getElementsByTagName('input')
                        if (inputs && inputs[0]) inputs[0].value = ""
                    }
                }
            })
            .catch(error => {
                console.error(error)
            })
    }
    return (
        <div>
        <input type="file" multiple={multiple} disabled={disabled} style={{fontSize: '0.8rem'}} onChange={(e) => {
            const pattern = /^\S[\s\S]*\S$|^\S$/;
            let files = e.target.files;
            let allValid = true;
            for(let i = 0; i < files.length; i++){
                if(!pattern.test(files[i]['name'])){
                    allValid = false;
                    break;
                }
            }
            if(allValid){
                change(e.target.files,props)
            }else{
                configStore.setModalMessage("Please Check File Name and Format")
                return e.target.value = ""
            }
            
        }} />
        </div>
    )
}

export function Agmongofile1(props) {
    useSnapshot(fileStore)
    const inputFileRef = useRef(null);

    const {parent} = props
    if(parent){
        if(fileStore.props[parent]==undefined){
            fileStore.props[parent] = props
        }
    }
    console.log(fileStore.props[parent])
    let url = `${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`
    const {label, filekey, disabled = false, callback = f => f} = props
    if(Agmongofileparentid.indexOf(parent)==-1){
        Agmongofileparentid.push(parent)
    }

    var parent_container = null
    var newHandle = function(e) { 
        let parent_container1 = null
        if(Agmongofileparentid.length>0 ){
            parent_container = e.target;
            do {
                if(parent_container){
                    parent_container = parent_container.parentNode;
                }else{
                    break
                }

                if (parent_container && Agmongofileparentid.indexOf(parent_container.id) == -1) {
                    parent_container1 = null
                }else{
                    parent_container1 = parent_container
                }
            }
            while( parent_container1==null && parent_container !== document.body );
            parent_container = parent_container1
        }
    };
    var newHandle1 = function(e) { 
        if(parent && parent_container){
            let i = parent_container.getElementsByTagName('input')
            i[0].files = e.clipboardData.files
            if(e.clipboardData.files.length>0){
                console.log(fileStore.props[parent_container.id])
                change(i[0].files,fileStore.props[parent_container.id])
            }
        }
    };
    if(Agmongofileparentid.length>0){
        document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
        document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
    
    }
    function change(files,props){
        const {label, filekey, disabled = false, callback = f => f} = props
        const {parent} = props
        const formData = new FormData()
        formData.append('myFile', files[0])
        formData.append('label', label)
        formData.append('key', filekey)
        fetch(url, {
            method: 'POST',
            headers: Api.H1(),
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                
                console.log('got data', data)
                if (data.error) { if (data.error!='No Error' || data.error!='Invalid Token') { configStore.setModalMessage(data.error) }}
                else {
                    //console.log('setting the filelink',  `/clientfiles/${files[0].name}`)
                    
                    callback(data,+parent.split('___')[1])
                    console.log("9099",parent)

                    //setFileName(data.key.filename)
                    //console.log(document.getElementById(parent).getElementsByTagName('input')[0].value)
                    //document.getElementById(parent).getElementsByTagName('input')[0].value = ""
                    if (inputFileRef.current) {
                        inputFileRef.current.value = "";
                    }
                }
            })
            .catch(error => {
                console.error(error)
            })
    }
    return (
        <div>
        <input type="file" disabled={disabled} 
        ref={inputFileRef}
        style={{fontSize: '0.8rem'}} 
        onChange={(e) => {
            const pattern = /^\S[\s\S]*\S$|^\S$/;
            const maxSizeInMB = 5;
            if(pattern.test(e.target.files[0]['name'])){
                if (e.target.files[0].size <= maxSizeInMB * 1024 * 1024) {
                    change(e.target.files, props);
                  } else {
                    configStore.setModalMessage("File size should not exceed 5MB");
                    e.target.value = "";
                  }
            }else{
                configStore.setModalMessage("Please Check File Name and Format")
                return e.target.value = ""
            }
          
        }} />
         
        </div>
    )
}

export function Agmongofiledlupload(props) {
    useSnapshot(fileStore)
    const {parent} = props
    if(parent){
        if(fileStore.props[parent]==undefined){
            fileStore.props[parent] = props
        }
    }
    console.log(fileStore.props[parent])
    let url = `${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`
    const {label, filekey, disabled = false, callback = f => f} = props
    if(Agmongofileparentid.indexOf(parent)==-1){
        Agmongofileparentid.push(parent)
    }

    var parent_container = null
    var newHandle = function(e) { 
        let parent_container1 = null
        if(Agmongofileparentid.length>0 ){
            parent_container = e.target;
            do {

                if(parent_container){
                    parent_container = parent_container.parentNode;
                }else{
                    break
                }
                

                if (parent_container && Agmongofileparentid.indexOf(parent_container.id) == -1) {
                    parent_container1 = null
                }else{
                    parent_container1 = parent_container
                }
            }
            while( parent_container1==null && parent_container !== document.body );
            parent_container = parent_container1
        }
    };
    var newHandle1 = function(e) { 
        if(parent && parent_container){
            let i = parent_container.getElementsByTagName('input')
            i[0].files = e.clipboardData.files
            if(e.clipboardData.files.length>0){
                console.log(fileStore.props[parent_container.id])
                change(i[0].files,fileStore.props[parent_container.id])
            }
        }
    };
    if(Agmongofileparentid.length>0){
        document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
        document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
    
    }
    function change(files,props){
        const {label, filekey, disabled = false, callback = f => f} = props
        const {parent} = props
        const formData = new FormData()
        formData.append('myFile', files[0])
        formData.append('label', label)
        formData.append('key', filekey)
        fetch(url, {
            method: 'POST',
            headers: Api.H1(),
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                
                console.log('got data', data)
                if (data.error) configStore.setModalMessage(data.error)
                else {
                    //console.log('setting the filelink',  `/clientfiles/${files[0].name}`)
                    callback(data,+parent.split('___')[1])
                    console.log(document.getElementById(parent).getElementsByTagName('input')[0].value)
                    document.getElementById(parent).getElementsByTagName('input')[0].value = ""
                }
            })
            .catch(error => {
                console.error(error)
            })
    }
    return (
        <div>
        <input type="file" disabled={disabled} style={{fontSize: '0.8rem'}} onChange={(e) => {
            // change(e.target.files,props)
            const pattern = /^\S[\s\S]*\S$|^\S$/;
            if(pattern.test(e.target.files[0]['name'])){
                change(e.target.files,props)
            }else{
                configStore.setModalMessage("Please Check File Name and Format")
                return e.target.value = ""
            }
            
        }} />
        </div>
    )
}

export function AgBtnmongofile(props) {
    useSnapshot(fileStore)
    const {parent} = props
    if(parent){
        if(fileStore.props[parent]==undefined){
            fileStore.props[parent] = props
        }
    }
    let url = `${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`
    const {btnname, label, filekey, disabled = false, callback = f => f} = props
    let parentid = ['ta4', 'ta5', 'ta6']
        var parent_container=null
        var newHandle = function(e) { 
            let parent_container1 = null
            if(parentid.length>0 ){
                parent_container = e.target;
                do {
                    if (!parent_container) break
                    parent_container = parent_container.parentNode;
    
                    if (parent_container && parentid.indexOf(parent_container.id) == -1) {
                        parent_container1 = null
                    }else{
                        parent_container1 = parent_container
                    }
                }
                while( parent_container1==null && parent_container !== document.body );
                parent_container = parent_container1
            }
        };
        var newHandle1 = function(e) { 
            if(parent && parent_container){
                let i = parent_container.getElementsByTagName('input')
                i[0].files = e.clipboardData.files
                if(e.clipboardData.files.length>0){
                    change(i[0].files,fileStore.props[parent_container.id])
                }
            }
        };
        if(parentid.length>0){
            document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
            document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
        
        }
        function change(files,props){
            const {parent} = props
            const {btnname, label, filekey, disabled = false, callback = f => f} = props
            const formData = new FormData()
            formData.append('myFile', files[0])
            formData.append('label', label)
            formData.append('key', filekey)
            fetch(url, {
                method: 'POST',
                headers: Api.H1(),
                credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    console.log('got data', data)
                    if (data.error) { if (data.error!='No Error' || data.error!='Invalid Token') { configStore.setModalMessage(data.error) }}
                    else {
                        //console.log('setting the filelink',  `/clientfiles/${files[0].name}`)
                        callback(data)
                        document.getElementById(parent).getElementsByTagName('input')[0].value = ""
                    }
                })
                .catch(error => {
                    console.error(error)
                })
        }
    return (
    
        <div class="file is-justify-content-center" >
    <label class="file-label">
    <input class="file-input" type="file" disabled={disabled} onChange={(e) => {
        //    change(e.target.files,props)
           const pattern = /^\S[\s\S]*\S$|^\S$/;
           if(pattern.test(e.target.files[0]['name'])){
               change(e.target.files,props)
           }else{
               configStore.setModalMessage("Please Check File Name and Format")
               return e.target.value = ""
           }
           
        }} />
    <span class="file-cta islink is-justify-content-center" style={{width:"25rem"}}>
      <span class="file-icon">
        <i class="fas fa-upload"></i>
      </span>
      <span class="file-label">
      {btnname}
      </span>
    </span>
    </label>
    </div>
    )
    }
export function AgBtnmongofilenew(props) {
        useSnapshot(fileStore)
        const {parent} = props
        if(parent){
            if(fileStore.props[parent]==undefined){
                fileStore.props[parent] = props
            }
        }
        let url = `${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`
        const {btnname, label, filekey, disabled = false, callback = f => f} = props
        let parentid = ['ta4', 'ta5', 'ta6','vin']
            var parent_container=null
            var newHandle = function(e) { 
                let parent_container1 = null
                if(parentid.length>0 ){
                    parent_container = e.target;
                    do {
                        if (!parent_container) break
                        parent_container = parent_container.parentNode;
        
                        if (parent_container && parentid.indexOf(parent_container.id) == -1) {
                            parent_container1 = null
                        }else{
                            parent_container1 = parent_container
                        }
                    }
                    while( parent_container1==null && parent_container !== document.body );
                    parent_container = parent_container1
                }
            };
            var newHandle1 = function(e) { 
                if(parent && parent_container){
                    let i = parent_container.getElementsByTagName('input')
                    i[0].files = e.clipboardData.files
                    if(e.clipboardData.files.length>0){
                        change(i[0].files,fileStore.props[parent_container.id])
                    }
                }
            };
            if(parentid.length>0){
                document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
                document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
            
            }
            function change(files,props){
                const {parent} = props
                const {btnname, label, filekey, disabled = false, callback = f => f} = props
                const formData = new FormData()
                formData.append('myFile', files[0])
                formData.append('label', label)
                formData.append('key', filekey)
                fetch(url, {
                    method: 'POST',
                    headers: Api.H1(),
                    credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
                    body: formData
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log('got data', data)
                        if (data.error) { if (data.error!='No Error' || data.error!='Invalid Token') { configStore.setModalMessage(data.error) }}
                        else {
                            //console.log('setting the filelink',  `/clientfiles/${files[0].name}`)
                            callback(data)
                            document.getElementById(parent).getElementsByTagName('input')[0].value = ""
                        }
                    })
                    .catch(error => {
                        console.error(error)
                    })
            }
        return (
        <>
            <input class="file-input" type="file" id={parent+"file"} disabled={disabled} onChange={(e) => {
                const pattern = /^\S[\s\S]*\S$|^\S$/;
                if(pattern.test(e.target.files[0]['name'])){
                    change(e.target.files,props)
                }else{
                    configStore.setModalMessage("Please Check File Name and Format")
                    return e.target.value = ""
                }
             }} />
             <label for={parent+"file"} class="btn-3">
                  <span class="d-flex aligncenter"><img src="./assets/file (1).png" alt="File" class="file-img" /> Upload</span>
                  <img src="./assets/upload(1).png" alt="Upload" class="upload-img" />
                </label>
                </>
        )
        }
export function Agmongofilenew(props) {
            useSnapshot(fileStore)
            const {parent} = props
            if(parent){
                if(fileStore.props[parent]==undefined){
                    fileStore.props[parent] = props
                }
            }
            console.log(fileStore.props[parent])
            let url = `${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`
            const {label, filekey, disabled = false, callback = f => f} = props
            if(Agmongofileparentid.indexOf(parent)==-1){
                Agmongofileparentid.push(parent)
            }
        
            var parent_container = null
            var newHandle = function(e) { 
                let parent_container1 = null
                if(Agmongofileparentid.length>0 ){
                    parent_container = e.target;
                    do {
                        if(parent_container){
                            parent_container = parent_container.parentNode;
                        }else{
                            break
                        }
        
                        if (parent_container && Agmongofileparentid.indexOf(parent_container.id) == -1) {
                            parent_container1 = null
                        }else{
                            parent_container1 = parent_container
                        }
                    }
                    while( parent_container1==null && parent_container !== document.body );
                    parent_container = parent_container1
                }
            };
            var newHandle1 = function(e) { 
                if(parent && parent_container){
                    let i = parent_container.getElementsByTagName('input')
                    i[0].files = e.clipboardData.files
                    if(e.clipboardData.files.length>0){
                        console.log(fileStore.props[parent_container.id])
                        change(i[0].files,fileStore.props[parent_container.id])
                    }
                }
            };
            if(Agmongofileparentid.length>0){
                document.getElementsByTagName('body')[0].onclick = function(e) {newHandle(e)}
                document.getElementsByTagName('body')[0].onpaste = function(e) {newHandle1(e)}
            
            }
            function change(files,props){
                const {label, filekey, disabled = false, callback = f => f} = props
                const {parent} = props
                const formData = new FormData()
                formData.append('myFile', files[0])
                formData.append('label', label)
                formData.append('key', filekey)
                fetch(url, {
                    method: 'POST',
                    headers: Api.H1(),
                    credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit', 
                    body: formData
                })
                    .then(response => response.json())
                    .then(data => {
                        
                        console.log('got data', data)
                        if (data.error) { if (data.error!='No Error' || data.error!='Invalid Token') { configStore.setModalMessage(data.error) }}
                        else {
                            //console.log('setting the filelink',  `/clientfiles/${files[0].name}`)
                            callback(data,+parent.split('___')[1])
                            console.log(document.getElementById(parent).getElementsByTagName('input')[0].value)
                            document.getElementById(parent).getElementsByTagName('input')[0].value = ""
                        }
                    })
                    .catch(error => {
                        console.error(error)
                    })
            }
            return (
                <>
                <input type="file" id={parent+"file"} disabled={disabled} onChange={(e) => {
                    const pattern = /^\S[\s\S]*\S$|^\S$/;
                    if(pattern.test(e.target.files[0]['name'])){
                        change(e.target.files,props)
                    }else{
                        configStore.setModalMessage("Please Check File Name and Format")
                        return e.target.value = ""
                    }
                }}/>
    <label for={parent+"file"} class="btn-3 width-200 height-45">
      <span class="d-flex aligncenter"><img src="./assets/file (1).png" alt="File" class="file-img" /> Upload</span>
      <img src="./assets/upload(1).png" alt="Upload" class="upload-img" />
    </label>
                </>
               
            )
        }
